import React, { useEffect, useState } from 'react'
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import {
    Form,
    Button,
    Modal,
} from "react-bootstrap";
import './printCauseListWithReason.css'
import { Context } from "../../../auth/Context";
import Swal from "sweetalert2";
import "../cases/SweetAlertOverrides.css";

const PastCauseListWithSisterReason = () => {

    const [isLoading, setLoading] = useState(false);
    const [dailyCauseList, setDailyCauseList] = useState([]);
    const [dateFrom, setDateFrom] = useState('');
    const [attachReasonModal, setAttachReasonModal] = useState(false);
    const [dateTo, setDateTo] = useState('');

    const [caseReasonId, setCaseReasonId] = useState("");
    // const [caseDiaryId, setCaseDiaryId] = useState("");
    const [reason, setReason] = useState("");
    const [remark, setRemark] = useState("");

    // state for reason modal
    const [case_diary_id, setCaseDiaryId] = useState('');

    const handleReasonSubmit = async (e) => {
        e.preventDefault();

        if (!reason || !reason.trim()) {
            alert("Reason is required");
            return;
        }

        setLoading(true);

        try {
            let res;

            if (caseReasonId) {
                res = await endpoint.put(`/case-diary/case-reason/${caseReasonId}`, {
                    reason,
                    remark,
                });
            } else {
                res = await endpoint.post(`/case-diary/case-reason`, {
                    case_diary_id: case_diary_id,
                    reason,
                    remark,
                });
            }

            Swal.fire("Success!", "Reason and remark saved successfully.", "success");

            setAttachReasonModal(false);
            setCaseReasonId("");
            setCaseDiaryId("");
            setReason("");
            setRemark("");

            handleFetchData();
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteReason = async (id) => {
        // const confirmed = window.confirm("Are you sure you want to delete this reason?");
        // if (!confirmed) return;

        // setLoading(true);

        try {
            const res = await endpoint.delete(`/case-diary/case-reason/${id}`);
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Do you really want to delete reason?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Yes!",
                customClass: {
                    confirmButton: "swal2-confirm-green-text",
                    cancelButton: "swal2-confirm-green-text",
                },
            });
            // console.log("delete reason response", res.data);
            if (result.isConfirmed) {
                handleFetchData();
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    const dateSuffix = (day) => {
        if ((day == 1) || (day == 21) || (day == 31)) {
            return day + '' + "st";
        } else if ((day == 2) || (day == 22)) {
            return day + '' + "nd";
        } else if ((day == 3) || (day == 23)) {
            return day + '' + "rd";
        } else {
            return day + '' + "th";
        }
    }

    const formattedDate = dateFrom && (new Date(dateFrom).toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(new Date(dateFrom).toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        new Date(dateFrom).toLocaleDateString('en-us', { month: "long" }) + ", " + new Date(dateFrom).toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const curDate = new Date()
    const dateStr = (curDate.toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(curDate.toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        curDate.toLocaleDateString('en-us', { month: "long" }) + ", " + curDate.toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const alphabetForSisterCase = "abcdefghijklmnopqrstuvwxyz".split("");


    const handleFetchData = async () => {
        setLoading(true)
        await endpoint.post(`/case-diary/past-cause-weekly-list-by-date`, { date: dateFrom })
            .then(({ data }) => {
                // console.log("response with supplied data", data.data)

                // return;
                let causeArr = data.data

                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A'; // fallback if location is missing

                    if (!result[location]) {
                        result[location] = {};
                    }

                    const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat + ' ' + (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : '');

                    if (!result[location][key]) {
                        result[location][key] = [];
                    }

                    result[location][key].push(obj);

                    return result;
                }, []);
                // console.log("groupedByLocation", groupedByLocation)
                setDailyCauseList(groupedByLocation)

                setLoading(false)
            }).catch((err) => {
                console.log(err)
                setLoading(false)
            })
    }


    /////////HANDLE SPLIT /////////


    //function that adds "judgement" to heading
    const splitHeading = (str) => {
        const firstSpaceIndex = str.indexOf(' ')
        const firstPart = str.slice(0, firstSpaceIndex)
        return (firstPart + ' ' + 'Judgment').toUpperCase()
    }

    //function that removes the adjournment id from heading
    const removeNumber = (str) => {
        const result = str.replace(/[0-9]/g, '')
        return (result + ' ' + '(s)').toUpperCase()
    }

    return (
        <>
            {isLoading && <div className="d-flex align-items-center justify-content-center vh-100">
                <img
                    src={"/loading.gif"}
                    alt={""}
                    className="img-fluid"
                    style={{ maxWidth: "50px" }}
                />
            </div>}
            {!isLoading && <div id='divToPrint'>

                <div className='row mt-4' id='hideDate'>
                    <div className='col-md-12'>
                        <div
                            className="p-4 p-md-5 mb-4"
                            style={{
                                background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
                                border: "1px solid #dbeafe",
                                borderRadius: "18px",
                                boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
                            }}
                        >
                            <div className='text-center mb-4' id='hideDate'>
                                <div
                                    style={{
                                        display: "inline-block",
                                        padding: "8px 18px",
                                        borderRadius: "999px",
                                        background: "#ffffff",
                                        border: "1px solid #dbeafe",
                                        color: "#1d4ed8",
                                        fontWeight: 700,
                                        fontSize: "13px",
                                        letterSpacing: "1px",
                                        textTransform: "uppercase",
                                        marginBottom: "14px",
                                    }}
                                >
                                    Cause List Module
                                </div>

                                <h3
                                    style={{
                                        marginBottom: "8px",
                                        fontWeight: 800,
                                        color: "#0f172a",
                                        textDecoration: "underline",
                                        textUnderlineOffset: "8px",
                                    }}
                                >
                                    REASON FOR CAUSE LIST
                                </h3>

                                <p
                                    className='mb-0'
                                    style={{
                                        color: "#475569",
                                        fontSize: "14px",
                                    }}
                                >
                                    Select a date to retrieve the relevant cause list and manage assigned reasons.
                                </p>
                            </div>

                            <div className='row align-items-end g-3'>
                                <div className='col-lg-12 col-md-8'>
                                    <label
                                        className='mb-2'
                                        id='hideDate'
                                        style={{
                                            fontWeight: 600,
                                            color: "#334155",
                                            display: "block",
                                        }}
                                    >
                                        Select Date
                                    </label>

                                    <div
                                        className="input-group"
                                        id='hideDate'
                                        style={{
                                            background: "#fff",
                                            borderRadius: "14px",
                                            overflow: "hidden",
                                            border: "1px solid #cbd5e1",
                                            boxShadow: "0 4px 14px rgba(15, 23, 42, 0.04)",
                                        }}
                                    >
                                        <input
                                            type="date"
                                            className="form-control"
                                            aria-label="From Date"
                                            aria-describedby="button-addon2"
                                            value={dateFrom}
                                            onChange={(e) => setDateFrom(e.target.value)}
                                            style={{
                                                border: "none",
                                                minHeight: "48px",
                                                boxShadow: "none",
                                            }}
                                        />

                                        <button
                                            className="btn btn-primary px-4"
                                            type="button"
                                            onClick={handleFetchData}
                                            id="button-addon2"
                                            style={{
                                                borderRadius: 0,
                                                fontWeight: 600,
                                                minWidth: "120px",
                                            }}
                                        >
                                            Search
                                        </button>
                                    </div>

                                    <div
                                        className='mt-2'
                                        id='hideDate'
                                        style={{
                                            color: "#dc2626",
                                            fontSize: "13px",
                                            fontStyle: "italic",
                                        }}
                                    >
                                        {/* **Please select date and click on search to print cause list** */}
                                    </div>

                                </div>

                                <div className='col-lg-12 col-md-4' id='hideDate'>
                                    <div
                                        style={{
                                            background: "#ffffff",
                                            border: "1px dashed #cbd5e1",
                                            borderRadius: "14px",
                                            padding: "14px 16px",
                                            color: "#dc2626",
                                            fontSize: "14px",
                                        }}
                                    >
                                        <strong style={{ color: "#0f172a" }}>Instruction:</strong> Select the applicable date and click <strong>Search</strong> to retrieve the cause list for review and printing.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {isLoading && <Loader />}

                {!isLoading && Object.entries(dailyCauseList).length > 0 &&

                    < div
                        className="p-4 p-md-5 mb-4"
                        style={{
                            background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
                            // border: "1px solid #dbeafe",
                            // borderRadius: "18px",
                            boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
                        }}
                    >
                        <div className='row mt-4'>
                            <div className='col-md-12'>

                                {Object.entries(dailyCauseList).map(([location, groupings], locationIndex) => {
                                    // Find the first justiceAssignment in this location group
                                    let firstPanel = '';

                                    // loop through all case groups under this location to find a panel
                                    for (const [_, cases] of Object.entries(groupings)) {
                                        for (const caseItem of cases) {
                                            if (caseItem.justiceAssignment && caseItem.justiceAssignment.length > 0) {
                                                firstPanel = caseItem.justiceAssignment[0].panel || '';
                                                break;
                                            }
                                        }
                                        if (firstPanel) break;
                                    }
                                    return (<div key={locationIndex}>
                                        {/* Location Header */}
                                        <div className='text-center mb-4' style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
                                            IN THE SUPREME COURT OF NIGERIA<br /> HOLDEN AT ABUJA <br /> CAUSE LIST FOR {dateFrom ? formattedDate : dateStr.toUpperCase()} <br />
                                            {location.toUpperCase()} {firstPanel && <span>({firstPanel})</span>}
                                        </div>

                                        {Object.entries(groupings).sort(([keyA], [keyB]) => {
                                            const isMotionA = keyA.toLowerCase().includes("motion");
                                            const isMotionB = keyB.toLowerCase().includes("motion");

                                            if (isMotionA && !isMotionB) return -1; // Motion first
                                            if (!isMotionA && isMotionB) return 1;  // Appeal after Motion

                                            return keyA.localeCompare(keyB); // alphabetical fallback
                                        }).map(([headings, items], index) => (
                                            <div className='causeListHeading' key={index}>
                                                <div className='causeListSecondHeading text-center mb-2' style={{
                                                    color: `${headings.toUpperCase().includes("CIVIL") ? 'green' : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`
                                                }}>
                                                    {headings.includes(2) ? `${alphabetArray[index]}. ${splitHeading(headings)}` : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                                                </div>

                                                <div className='table-reponsive'>
                                                    <table className="table mb-5" style={{ width: `100%` }}>
                                                        <thead className="thead-light">
                                                            <tr style={{ border: `1px solid black` }}>
                                                                <th style={{ maxWidth: `5px`, border: `1px solid black` }}>SN.</th>
                                                                <th scope="col" style={{ border: `1px solid black` }}>APPEAL NO.</th>
                                                                {headings.toUpperCase().includes("APPEAL") ?
                                                                    <>
                                                                        <th scope="col" style={{ border: `1px solid black` }}>APPELLANTS</th>
                                                                        <th scope="col" style={{ border: `1px solid black` }}>RESPONDENTS</th>
                                                                    </>
                                                                    : <>
                                                                        <th scope="col" style={{ border: `1px solid black` }}>PARTIES</th>
                                                                    </>
                                                                }
                                                                <th scope="col" style={{ border: `1px solid black` }}>REASON</th>
                                                                <th scope="col" id='hideDate' style={{ border: `1px solid black` }}>ACTION</th>

                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {items.map((item, index) => (
                                                                <React.Fragment key={index}>
                                                                    {item.CaseAttachements && item.CaseAttachements.map((Case, index2) => {
                                                                        const hasSisters = item.CaseAttachements.length > 1;

                                                                        return (
                                                                            <tr key={`${index}-${index2}`} style={{ border: `1px solid black` }}>
                                                                                {(index2 === 0) && (
                                                                                    <td
                                                                                        rowSpan={item.CaseAttachements.length}
                                                                                        style={{ border: `1px solid black` }}
                                                                                    >
                                                                                        {index + 1}.
                                                                                    </td>
                                                                                )}

                                                                                <td style={{ border: `1px solid black`, color: `${item.CaseType.case_color}` }}>
                                                                                    <strong>
                                                                                        {hasSisters ? `${alphabetForSisterCase[index2]}. ${Case.suite_no}` : Case.suite_no}
                                                                                    </strong>
                                                                                </td>

                                                                                {headings.toUpperCase().includes("APPEAL") ? (
                                                                                    <>
                                                                                        <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                            <div>
                                                                                                {Case.appellants}
                                                                                                {Case.otherAppellantCount === 1 ? (
                                                                                                    <> <strong>& Anor</strong></>
                                                                                                ) : Case.otherAppellantCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </div>
                                                                                        </td>

                                                                                        <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                            <div>
                                                                                                {Case.respondent}
                                                                                                {Case.otherRespondentCount === 1 ? (
                                                                                                    <> <strong>& Anor</strong></>
                                                                                                ) : Case.otherRespondentCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </div>
                                                                                        </td>

                                                                                        {index2 === 0 && (
                                                                                            <td
                                                                                                rowSpan={item.CaseAttachements.length}
                                                                                                style={{
                                                                                                    border: "1px solid black",
                                                                                                    wordBreak: "break-word",
                                                                                                    whiteSpace: "pre-wrap",
                                                                                                    maxWidth: "250px",
                                                                                                    verticalAlign: "top",
                                                                                                }}
                                                                                            >
                                                                                                {item.caseReasons && item.caseReasons.length > 0 ? (
                                                                                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                                                                        {item.caseReasons.map((reasonItem, reasonIndex) => (
                                                                                                            <div
                                                                                                                key={reasonItem.id || reasonIndex}
                                                                                                                style={{
                                                                                                                    border: "1px solid #d9d9d9",
                                                                                                                    borderRadius: "8px",
                                                                                                                    padding: "10px",
                                                                                                                    background: "#fafafa",
                                                                                                                }}
                                                                                                            >
                                                                                                                <div style={{ marginBottom: "6px" }}>
                                                                                                                    <strong>Reason:</strong> {reasonItem.reason ? reasonItem.reason : "N/A"}
                                                                                                                </div>

                                                                                                                <div style={{ marginBottom: "8px" }}>
                                                                                                                    <strong>Remark:</strong> {reasonItem.remark ? reasonItem.remark : "N/A"}
                                                                                                                </div>

                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        display: "flex",
                                                                                                                        gap: "8px",
                                                                                                                        flexWrap: "wrap",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        className="btn btn-sm btn-outline-success"
                                                                                                                        onClick={() => {
                                                                                                                            setCaseReasonId(reasonItem.id || "");
                                                                                                                            setCaseDiaryId(reasonItem.case_diary_id || Case.case_diary_id);
                                                                                                                            setReason(reasonItem.reason || "");
                                                                                                                            setRemark(reasonItem.remark || "");
                                                                                                                            setAttachReasonModal(true);
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <span className="fa fa-edit"> Edit</span>
                                                                                                                    </button>

                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        className="btn btn-sm btn-outline-danger"
                                                                                                                        onClick={() => handleDeleteReason(reasonItem.id)}
                                                                                                                    >
                                                                                                                        <span className="fa fa-trash"> Delete</span>
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div
                                                                                                        style={{
                                                                                                            border: "1px dashed #d1d5db",
                                                                                                            borderRadius: "12px",
                                                                                                            padding: "12px",
                                                                                                            background: "#ffffff",
                                                                                                            textAlign: "center",
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            style={{
                                                                                                                fontSize: "13px",
                                                                                                                fontWeight: 700,
                                                                                                                color: "#64748b",
                                                                                                                marginBottom: "6px",
                                                                                                            }}
                                                                                                        >
                                                                                                            No Reason Added
                                                                                                        </div>
                                                                                                        <div
                                                                                                            style={{
                                                                                                                fontSize: "13px",
                                                                                                                color: "#94a3b8",
                                                                                                            }}
                                                                                                        >
                                                                                                            Reason and remark are not available for this diary.
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>
                                                                                        )}

                                                                                        {(!hasSisters || index2 === 0) && (
                                                                                            <td
                                                                                                id='hideDate'
                                                                                                rowSpan={item.CaseAttachements.length}
                                                                                                style={{ border: `1px solid black`, verticalAlign: "top" }}
                                                                                            >
                                                                                                <button
                                                                                                    className="btn btn-success"
                                                                                                    type="button"
                                                                                                    onClick={() => {
                                                                                                        setCaseReasonId("");
                                                                                                        setCaseDiaryId(Case.case_diary_id);
                                                                                                        setReason("");
                                                                                                        setRemark("");
                                                                                                        setAttachReasonModal(true);
                                                                                                    }}
                                                                                                >
                                                                                                    <span className='fa fa-plus'> Add Reason</span>
                                                                                                </button>
                                                                                            </td>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <td
                                                                                            className='text-center'
                                                                                            style={{ whiteSpace: `normal`, border: `1px solid black` }}
                                                                                        >
                                                                                            <div>
                                                                                                {Case.appellants}
                                                                                                {Case.otherAppellantCount === 1 ? (
                                                                                                    <> <strong>& Anor</strong></>
                                                                                                ) : Case.otherAppellantCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </div>

                                                                                            <div className='mt-2 mb-2'>VS.</div>

                                                                                            <div>
                                                                                                {Case.respondent}
                                                                                                {Case.otherRespondentCount === 1 ? (
                                                                                                    <> <strong>& Anor</strong></>
                                                                                                ) : Case.otherRespondentCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </div>
                                                                                        </td>

                                                                                        {index2 === 0 && (
                                                                                            <td
                                                                                                rowSpan={item.CaseAttachements.length}
                                                                                                style={{
                                                                                                    border: "1px solid black",
                                                                                                    wordBreak: "break-word",
                                                                                                    whiteSpace: "pre-wrap",
                                                                                                    maxWidth: "250px",
                                                                                                    verticalAlign: "top",
                                                                                                }}
                                                                                            >
                                                                                                {item.caseReasons && item.caseReasons.length > 0 ? (
                                                                                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                                                                        {item.caseReasons.map((reasonItem, reasonIndex) => (
                                                                                                            <div
                                                                                                                key={reasonItem.id || reasonIndex}
                                                                                                                style={{
                                                                                                                    border: "1px solid #d9d9d9",
                                                                                                                    borderRadius: "8px",
                                                                                                                    padding: "10px",
                                                                                                                    background: "#fafafa",
                                                                                                                }}
                                                                                                            >
                                                                                                                <div style={{ marginBottom: "6px" }}>
                                                                                                                    <strong>Reason:</strong> {reasonItem.reason ? reasonItem.reason : "N/A"}
                                                                                                                </div>

                                                                                                                <div style={{ marginBottom: "8px" }}>
                                                                                                                    <strong>Remark:</strong> {reasonItem.remark ? reasonItem.remark : "N/A"}
                                                                                                                </div>



                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        display: "flex",
                                                                                                                        gap: "8px",
                                                                                                                        flexWrap: "wrap",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        className="btn btn-sm btn-outline-success"
                                                                                                                        onClick={() => {
                                                                                                                            setCaseReasonId(reasonItem.id || "");
                                                                                                                            setCaseDiaryId(reasonItem.case_diary_id || Case.case_diary_id);
                                                                                                                            setReason(reasonItem.reason || "");
                                                                                                                            setRemark(reasonItem.remark || "");
                                                                                                                            setAttachReasonModal(true);
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <span className="fa fa-edit"> Edit</span>
                                                                                                                    </button>

                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        className="btn btn-sm btn-outline-danger"
                                                                                                                        onClick={() => handleDeleteReason(reasonItem.id)}
                                                                                                                    >
                                                                                                                        <span className="fa fa-trash"> Delete</span>
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div
                                                                                                        style={{
                                                                                                            border: "1px dashed #d1d5db",
                                                                                                            borderRadius: "12px",
                                                                                                            padding: "12px",
                                                                                                            background: "#ffffff",
                                                                                                            textAlign: "center",
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            style={{
                                                                                                                fontSize: "13px",
                                                                                                                fontWeight: 700,
                                                                                                                color: "#64748b",
                                                                                                                marginBottom: "6px",
                                                                                                            }}
                                                                                                        >
                                                                                                            No Reason Added
                                                                                                        </div>
                                                                                                        <div
                                                                                                            style={{
                                                                                                                fontSize: "13px",
                                                                                                                color: "#94a3b8",
                                                                                                            }}
                                                                                                        >
                                                                                                            Reason and remark are not available for this diary.
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>
                                                                                        )}

                                                                                        {(!hasSisters || index2 === 0) && (
                                                                                            <td
                                                                                                id='hideDate'
                                                                                                rowSpan={item.CaseAttachements.length}
                                                                                                style={{ border: `1px solid black`, verticalAlign: "top" }}
                                                                                            >
                                                                                                <button
                                                                                                    className="btn btn-success"
                                                                                                    type="button"
                                                                                                    onClick={() => {
                                                                                                        setCaseReasonId("");
                                                                                                        setCaseDiaryId(Case.case_diary_id);
                                                                                                        setReason("");
                                                                                                        setRemark("");
                                                                                                        setAttachReasonModal(true);
                                                                                                    }}
                                                                                                >
                                                                                                    <span className='fa fa-plus'> Add Reason</span>
                                                                                                </button>
                                                                                            </td>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </React.Fragment>
                                                            ))}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                }

                {Object.entries(dailyCauseList).length > 0 &&
                    <div className='col-md-12 hideBtn'>
                        <button className="btn btn-outline-primary" type="button" onClick={() => window.print()} id="button-addon2">Print</button>
                    </div>
                }

                {/* attach ruling modal */}
                <Modal show={attachReasonModal} onHide={() => setAttachReasonModal(false)}>
                    <Modal.Header closeButton>
                        {/* <Modal.Title>Attach Reason for Case Assignment </Modal.Title> */}
                        <Modal.Title>
                            {caseReasonId ? "Edit Reason for Case Assignment" : "Attach Reason for Case Assignment"}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <form onSubmit={handleReasonSubmit}>

                            <Form.Group className="mb-3">
                                <Form.Label>Reason</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                >
                                    <option value="">Select...</option>
                                    <option value="COURT">COURT</option>
                                    <option value="OLD">OLD</option>
                                    <option value="CJN">CJN</option>
                                    <option value="ML">ML</option>
                                    <option value="OTHER">OTHER</option>
                                </Form.Control>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Remark/Comment</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                />
                            </Form.Group>


                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        setAttachReasonModal(false)
                                        setReason('')
                                        setRemark('')
                                        setCaseDiaryId('')
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="success"
                                    className="ms-2"
                                    disabled={isLoading || !reason}
                                >
                                    {isLoading ? "Saving..." : "Submit"}
                                </Button>
                            </div>
                        </form>
                    </Modal.Body>


                </Modal>
            </div >}
        </>

    )
}

export default PastCauseListWithSisterReason